module.exports = __webpack_public_path__ + "static/media/menu-versions.dddcb3b7.svg";